<template>
    <v-form ref="form" v-model="isValid">
        <v-card flat>
            <v-card-text>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            v-model="language.name"
                            :counter="64"
                            :error-messages="errorMessages.name"
                            :label="t('languages::create.label.name')"
                            :rules="rules.name"
                            dense
                            outlined
                            rounded
                            required
                        ></v-text-field>
                        <v-text-field
                            v-model="language.code"
                            :counter="2"
                            :error-messages="errorMessages.code"
                            :label="t('languages::create.label.code')"
                            :rules="rules.code"
                            dense
                            outlined
                            rounded
                            required
                            :disabled="language.id ? true : false"
                        ></v-text-field>
                        <v-text-field
                            v-model="language.culture"
                            :counter="5"
                            :error-messages="errorMessages.culture"
                            :label="t('languages::create.label.culture')"
                            :rules="rules.culture"
                            dense
                            outlined
                            required
                            rounded
                            :disabled="language.id ? true : false"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-switch
                            v-show="defaultLanguageId != id"
                            v-model="language.is_active"
                            :error-messages="errorMessages.is_active"
                            :label="t('languages::create.label.is_active')"
                            class="mt-0"
                            dense
                        ></v-switch>
                        <v-switch
                            v-show="canChangeDefault"
                            v-model="language.is_default"
                            :error-messages="errorMessages.is_default"
                            :label="t('languages::create.label.is_default')"
                            class="mt-0"
                            dense
                            rounded
                        ></v-switch>
                    </v-col>
                </v-row>
            </v-card-text>
            <b-form-actions
                :id="id"
                :back-route="$root.route('languages.index')"
                @discard="discardChanges"
                @save="saveLanguage"
            ></b-form-actions>
        </v-card>
    </v-form>
</template>
<script>
let formSubmitMixin = require(process.env.MIX_APP_ROOT +
    '/bgo/bgo-components/resources/js/mixins/FormSubmit.js').default;

export default {
    name: 'LanguageDetails',
    mixins: [formSubmitMixin],
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isValid: true,
            loading: false,
            language: {},
            canChangeDefault: false,
            defaultLanguageId: null,
            rules: {
                name: [
                    (v) => !!v || t('languages::validation.name.required'),
                    (v) => (v && v.length <= 64) || t('languages::validation.name.max_length'),
                ],
                code: [
                    (v) => !!v || t('languages::validation.code.required'),
                    (v) => (v && v.length <= 2) || t('languages::validation.code.max_length'),
                ],
                culture: [
                    (v) => !!v || t('languages::validation.culture.required'),
                    (v) => (v && v.length <= 5) || t('languages::validation.culture.max_length'),
                ],
            },
            errorMessages: {
                name: [],
                code: [],
                culture: [],
                is_default: [],
                is_active: [],
            },
        };
    },
    created() {
        this.loadDefaultLanguage();
        this.loadLanguage();
    },
    methods: {
        async saveLanguage() {
            if (this.language.id) {
                this.submit(route('api.v1.languages.update', { language: this.id }), this.language, 'put', () => {
                    this.$root.notify('info', t('default::notification.saved'));
                    this.$root.goTo(route('languages.index'));
                });
            } else {
                this.submit(route('api.v1.languages.store'), this.language, 'post', () => {
                    this.$root.notify('info', t('default::notification.saved'));
                    this.$root.goTo(route('languages.index'));
                });
            }
        },
        discardChanges() {
            this.loadLanguage();
            this.$root.notify('info', t('languages::notification.changes_discarded'));
        },
        loadDefaultLanguage() {
            this.loading = true;

            axios.get(route('api.v1.languages.default')).then((response) => {
                let defaultLanguageId = _.isObject(response.data) && 'id' in response.data ? response.data.id : null;
                this.canChangeDefault = defaultLanguageId === this.id || defaultLanguageId === null;
                this.defaultLanguageId = defaultLanguageId;
                this.loading = false;
            });
        },
        loadLanguage() {
            if (!this.id) {
                return;
            }

            this.loading = true;

            axios
                .get(
                    route('api.v1.languages.show', {
                        language: this.id,
                        fields: 'id,name,code,culture,is_default,is_active',
                    })
                )
                .then((response) => {
                    this.language = response.data.data;
                    this.language.is_active = this.language.is_active === 1;
                    this.language.is_default = this.language.is_default === 1;
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped></style>
